<template>
    <div :class="{ 'show-mask':isShowMask }">
            <div class="select-picker"
                :class="{'show-select-address':isShowMask}">
                <div class="picker">
                    <div class="picker-title">
                        <div :hidden="!selectedProvince.name">
                            <div class="choose-city"
                                @click="clearRegion('0')">{{ selectedProvince.name }}</div>
                        </div>
                        <div :hidden="!selectedCity.name">
                            <div class="choose-city"
                                @click="clearRegion('1')">{{ selectedCity.name }}</div>
                        </div>
                        <div :hidden="!selectedCountry.name">
                            <div class="choose-city"
                                @click="clearRegion('2')">{{ selectedCountry.name }}</div>
                        </div>
                        <div :hidden="!showChoose">
                            <div class="choose-city  selected-city">请选择</div>
                        </div>
                        <div class="close-btn" @click="selectRegion">
                            <img class="closure" src="../../../static/runtime/images/magic/close-icon3.png">
                        </div>
                    </div>
                    <div class="city">
                        <div v-if="showProvinces"
                            class="list">
                            <div v-for="(item) in provinces"
                                :key="item.id"
                                class="view"
                                @click="selectProvinces(item)">{{ item.name?item.name:item.shortName }}</div>
                        </div>
                        <div v-if="showCities"
                            class="list">
                            <div v-for="(item) in cities"
                                :key="item.id"
                                class="view"
                                @click="selectCity(item)">{{ item.name?item.name:item.shortName }}</div>
                        </div>
                        <div v-if="showCounties"
                            class="list">
                            <div v-for="(item) in country"
                                :key="item.id"
                                class="view"
                                @click="selectCounty(item)">{{ item.name?item.name:item.shortName }}</div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>
<script lang="js">
import { config } from '../../api/config.js';
import { Toast } from 'vant';
export default {
   data(){
       return{
        provinces: [], //省列表
        cities: [], //市列表
        country: [], //县(区)列表
        selectedProvince:{}, //已经选择的省份
        selectedCity:{}, //已经选择的市
        selectedCountry:{}, //已经选择的区
        isShowMask: false, //是否显示蒙层
        showChoose: false, // 是否显示请选择
        showProvinces: true, // 是否显示省份列表,默认true
        showCities: false,
        showCounties: false,
      }
   },
   //初始化后调用
  async mounted() {
    this.showProvinces = true;
    this.showCities = false;
    this.showCounties = false;
    this.showChoose = true;
    const param = {
      level: "province",
      parentId: "10000044"
    }
    this.provinces = await this.getOnlineGeographyTree(param)
  },
   methods: {
// 显示弹窗
    async showDialog() {
      this.isShowMask = true;
      if(!this.provinces||this.provinces.length === 0){
        const param = {
          level: "province",
          parentId: "10000044"
        }
        const provinces = await this.getOnlineGeographyTree(param)
        if(provinces.length > 0){
          this.provinces = provinces
        }else{
          Toast('加载失败，请关闭弹窗重新选择');
        }
      }
    },
    // 点击选择收货地址
    selectRegion() {
      this.isShowMask = false
      this.$emit('cancel')
    },

    // 选择省
    async selectProvinces(item) {
      const data = {
        parentId: item.id,
        level: 'city',
      };
      const cities = await this.getOnlineGeographyTree(data)
      if(cities.length > 0){
        this.cities = cities;
        this.selectedProvince = item;
        this.showProvinces = false;
        this.showCities = true;
        this.showCounties = false;
        this.showChoose = true;
      }else{
        Toast('加载失败，请再次选择省份');
      }
    },

    // 选择城市
    async selectCity(item) {
      const data = {
        parentId: item.id,
        level: 'county',
      };
      const country = await this.getOnlineGeographyTree(data)
      if(country.length > 0){
        this.country = country;
        this.selectedCity = item;
        this.showProvinces = false;
        this.showCities = false;
        this.showCounties = true;
        this.showChoose = true;
      }else{
        Toast('加载失败，请再次选择城市');
      }
    },

    // 选择县城或者区,cityId编辑时候根据id查对应的
    selectCounty(item) {
      this.selectedCountry = item;
      this.showProvinces = false;
      this.showCities = false;
      this.showCounties = false;
      this.showChoose = false;
      this.isShowMask = false
      this.$emit('selectArea',[this.selectedProvince,this.selectedCity,this.selectedCountry])
      console.log('选择的全部省市区',[this.selectedProvince,this.selectedCity,this.selectedCountry])
    },

    // 点击清除下一级
    clearRegion(num) {
      switch (num) {
        case '0':
          this.selectedProvince = {};
          this.selectedCity = {};
          this.selectedCountry = {};
          this.showChoose = true;
          this.showProvinces = true;
          this.showCities = false;
          this.showCounties = false;
          this.cities = [];
          this.country = []
          break;
        case '1':
          this.selectedCity = {};
          this.selectedCountry = {};
          this.showChoose = true;
          this.showProvinces = false;
          this.showCities = true;
          this.showCounties = false;
          this.country = []
          break;
        case '2':          
          this.selectedCountry = {};
          this.showChoose = true;
          this.showProvinces = false;
          this.showCities = false;
          this.showCounties = true;
          break;
      }
    },
    getOnlineGeographyTree(param){
      return new Promise((resolve, reject) => {
        this.$api.post({
          sc: 'sms',
          url: config.geographyTree,
          params: param,
          success: (r) => {
            if(r && r.status && r.status === "success" && r.result && r.result.length > 0){
              resolve(r.result);
            }else{
              resolve([])
            }
          },
          error: (e) => {
            resolve([])
          }
        })
      })
    },
   }
};
</script>
<style lang="scss" scoped>
.show-mask {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}
.select-picker {
  height: 375px;
  width: 100%;
  position: fixed;
  bottom: -375px;
  left: 0;
  z-index: 9999;
  transition: 0.15s linear;
  background: #fff;

  .picker {
    .picker-title {
      background: #fff;
      justify-content: flex-start;
      display: flex;
      height: 47px;
      margin: 0 15px;
      box-sizing: border-box;
      border-bottom: 0.5px solid #f5f5f5;
      font-size: 14px;
      letter-spacing: 1px;
      padding-top: 15px;
      .choose-city {
        color: #000000;
        line-height: 17px;
        font-weight: 500;
        height: 47px;
        display: flex;
        justify-content: center;
        width: auto;
        padding-right: 25px;
      }

      .selected-city {
        font-size: 14px;
        color: #256fff;
        border-bottom: solid 3px #256fff;
        height: calc(100% - 3px);
        line-height: 17px;
        padding-right: 0;
        font-weight: 400;
      }
    }

    // 滚动部分的样式
    .city {
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 1px;
      padding-left: 15px;
      height: 280px;
      overflow-y: auto;
      color: #333333;
      .list {
        .view {
          padding: 11px 0;
        }
      }
    }
  }
}
.close-btn {
    position: fixed;
    right: 15px;
    width: 15px;
    height: 15px;
    .closure {
      width: 15px;
      height: 15px;
    }
  }
//控制地区选择器展示
.show-select-address {
  bottom: 0px;
}
</style>
<style lang="scss">
.address-info-add {
  u-field {
    width: 100%;
  }

  .u-field {
    padding: 0 !important;

    .u-textarea-class {
      min-height: 25px !important;
      padding: 1px 0px !important;
      font-size: 14px !important;
    }

    .u-field__input-wrap {
      font-size: 14px !important;
      color: #000000 !important;
      font-weight: 400;
      padding: 1px 0px !important;
      height: 24px !important;
    }
    .u-required::before {
      left: -8px !important;
      color: #e02020 !important;
    }
  }

  ::v-deep .u-label {
    width: 65px !important;
    color: #999999;
    font-weight: 400;
    margin-right: 10px;
    font-size: 14px;
    white-space: nowrap;
    flex: 0 0 61px !important;
  }
  .detail-address {
    ::v-deep .u-label {
      height: 35px !important;
      margin-right: 5px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modal/area-select.vue